/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".qb-hero[_ngcontent-%COMP%]   .lead[_ngcontent-%COMP%], .qb-hero[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
